"use client"

import { useEffect } from "react"
import Script from "next/script"

declare global {
  interface Window {
    OneSignalDeferred: any[];
  }
}

export default function OneSignalPush() {
  useEffect(() => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(function(OneSignal: any) {
      OneSignal.init({
        appId: "YOUR_ONESIGNAL_APP_ID", // TODO: Replace with your App ID
        safari_web_id: "web.onesignal.auto.12345",
        notifyButton: {
          enable: true, // This enables the non-intrusive bell prompt instead of aggressive popups
        },
      });
    });
  }, []);

  return (
    <>
      <Script src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js" strategy="lazyOnload" />
    </>
  )
}
